import { render, staticRenderFns } from "./FramerateMarkerInspector.vue?vue&type=template&id=10ac8f82&scoped=true&"
import script from "./FramerateMarkerInspector.vue?vue&type=script&lang=js&"
export * from "./FramerateMarkerInspector.vue?vue&type=script&lang=js&"
import style0 from "./FramerateMarkerInspector.vue?vue&type=style&index=0&id=10ac8f82&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ac8f82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/akryum/Projects/vue-devtools/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10ac8f82')) {
      api.createRecord('10ac8f82', component.options)
    } else {
      api.reload('10ac8f82', component.options)
    }
    module.hot.accept("./FramerateMarkerInspector.vue?vue&type=template&id=10ac8f82&scoped=true&", function () {
      api.rerender('10ac8f82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@vue-devtools/app-frontend/src/views/perf/FramerateMarkerInspector.vue"
export default component.exports